import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import { history } from '../store/configureStore';
import MainRoute from '../router';
import Header from '../components/Header';

import { useDispatch, useSelector } from 'react-redux';

import ToastPortalContainer from '../components/ToastContainer';
import { getUserProfile, userNameSelector } from '../ducks/profile';
import { isAuthSelector } from '../ducks/login';
import { Dimmer, Loader } from 'semantic-ui-react';
import ModalInfo from "../components/ModalInfo";

const App = () => {
    const dispatch = useDispatch();
    const userName = useSelector(state => userNameSelector(state));
    const isAuth = useSelector(state => isAuthSelector(state));

    const getProfile = () => {
        if (!userName) {
            dispatch(getUserProfile());
        }
    };

    useEffect(getProfile, []);

    return (
        <>
            <Router history={history}>
                {userName || !isAuth ? (
                    <>
                        <Header />
                        <MainRoute />
                    </>
                ) : (
                    <Dimmer active inverted>
                        <Loader size="huge">Loading</Loader>
                    </Dimmer>
                )}
            </Router>
            <ToastPortalContainer />
            <ModalInfo />
        </>
    );
};

export default App;
